import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutFuelCardQuickInfo } from "./autogen/AutogenLayoutFuelCardQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class FuelCardQuickInfo extends AutogenLayoutFuelCardQuickInfo {

    /** This is an event handler for the afterExecution event of sourceFuelCardLookup. */
    sourceFuelCardLookupAfterExecution(event: DataSourceExecutionEvent) {
        this.textboxId.printableLabel.link = LayoutUrl.create("lme/dispatch/asset/FuelCard", {
            mode: "update",
            key: `${event.data?.get("id")},${event.data?.get("account_id")},` +
                `${event.data?.get("sub_account")},${event.data?.get("fuel_interface_id")}`,
        });
    }

}
